import React from "react";
import { UiComponents } from "@simulanisindia/ui";
import GeographicalCharts from "../../components/Charts/GeographicalCharts";

const { SimToggleSwitch } = UiComponents;
const HeatMapGraph = () => {
  return (
    <>
      <div className="chart-parent">
        <div className="chat-infos">
          <h6>Heat Map</h6>
          <p>
            {" "}
            <span>(+100) more</span> in 2024{" "}
          </p>
        </div>
        <div className="mapWrapper">
          <div className="mapSide">
            <GeographicalCharts />
          </div>
          <div className="mapFunctions">
            <div className="functionItem">
              <p>Prop</p>
              <SimToggleSwitch
              />
            </div>
            <div className="functionItem">
              <p>Prop</p>
              <SimToggleSwitch
              />
            </div>
            <div className="functionItem">
              <p>Prop</p>
              <SimToggleSwitch
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeatMapGraph;
